import V from 'voUtils/V.js';
import DateEx from 'voUtils/DateEx.js';


import {
	doReq
}
from 'voUtils/RestEx.js';

import {
	findResultFields
}
from 'voUtils/BrowserEx.js';

export default {
	data: function () {
		return {
			units: [],
			imagesForModal: []
		};
	},
	beforeMount: function () {
		var results = this.$el.getElementsByClassName('unit-list-section');
		if (results.length) {
			this.resultFields = findResultFields(results[0].innerHTML, this.$el);
		}

		var req = {
			fields: this.resultFields,
			filter: {
				childrenWelcome: true
			},
			sorting: 'random',
			max: 6
		};

		doReq('searchUnits', req)
			.then((res) => {
				//console.log(res.units);
				this.units = res.units;
			});

	},

	updated: function () {
		this.applySlider();
		$('[data-toggle="tooltip"]').tooltip();
		$('[data-toggle="popover"]').popover();


	},
	methods: {
		applySlider: function () {
			const $carousel = $(".owl-carousel.pets-units");

			const $wrapper = $carousel.closest(".carousel-wrapper");

			// Keyboard- vs. Maus-Nutzung verfolgen
			let isUsingKeyboard = false;

			window.addEventListener('keydown', (e) => {
				if (e.key === 'Tab') {
					isUsingKeyboard = true;
				}
			});
			window.addEventListener('mousedown', () => {
				isUsingKeyboard = false;
			});

			// Parameter aus alten Script übernehmen !!!!!!!
			if (!$carousel.hasClass('owl-loaded')) {
				$carousel.owlCarousel({
					loop: false,
					margin: VOFFICE.settings.olwCarouselMargin,
					smartSpeed: 1000,
					autoplay: false,
					nav: VOFFICE.settings.olwCarouselNav,
					dots: true,
					responsive: {
						0: {
							items: 1
						},
						768: {
							items: 2
						},
						996: {
							items: 3
						},
						1200: {
							items: 3

						}
					},
					onInitialized: function () {
						updateDots(); // <-- Neue Funktion aufrufen
					}
				});
			}

			function updateDots() {
				$carousel.find('.owl-dot').each(function (index) {
					$(this).find('span').html('<span class="sr-only">Gehe zu Slide ' + (index + 1) + '</span>');
					// Optional: ARIA-Label hinzufügen
					$(this).attr('aria-label', 'Gehe zu Slide ' + (index + 1));
				});
			}

			function updateTabindex() {
				$(".owl-item").each(function () {
					const $item = $(this);
					$item.find('a, button, input, select, textarea, [tabindex]').each(function () {
						if (!$item.hasClass("active")) {
							$(this).attr("tabindex", "-1");
						} else {
							if ($(this).attr("tabindex") === "-1" && !$(this).hasClass("notremovetabindex")) {
								$(this).removeAttr("tabindex");
							}
						}
					});
				});
			}

			// Initial aufrufen
			updateTabindex();

			const that = this;

			// Prev/Next Buttons vorbereiten
			const $navButtons = $(".owl-prev, .owl-next");
			$navButtons.attr({
				"tabindex": "0",
				"aria-label": function () {
					return $(this).hasClass('owl-prev') ? that.voMsg('tpl.text.prevSlide') : that.voMsg('tpl.text.nextSlide');
				}
			});

			// Tastatur-Fokus anzeigen
			$navButtons
				.off('focus.keyboard-focus blur.keyboard-focus')
				.on('focus.keyboard-focus', function () {
					if (isUsingKeyboard) {
						$(this).addClass('keyboard-focus');
					}
				})
				.on('blur.keyboard-focus', function () {
					$(this).removeClass('keyboard-focus');
				});

			// Tastatursteuerung über Wrapper
			$wrapper.attr("tabindex", "0").off("keydown.owlNav").on("keydown.owlNav", function (e) {
				if (e.key === "ArrowLeft") {
					$carousel.trigger("prev.owl.carousel");
					e.preventDefault();
				} else if (e.key === "ArrowRight") {
					$carousel.trigger("next.owl.carousel");
					e.preventDefault();
				}
			});

			// Tabindex nach jedem Slide-Wechsel aktualisieren
			$carousel.off("changed.owl.carousel").on("changed.owl.carousel", function () {
				setTimeout(() => {
					updateTabindex();
				}, 100);
			});
		},
		getUnitSearchTarget: function (id) {
			return 'unit_' + id;
		},
	}

};